export default __webpack_public_path__ + "static/media/header_small.d90cff3e.png";